<template lang="pug">
#business_intro
  //- 商品介紹頁-區塊一
  .container.container_shrink.i_pb_4
    .row.flex-md-row-reverse.justify-content-md-between
      .col-12.col-md-auto.text-center
        img.banner(:style="setBanner")
    .row.i_mt_8
      .col-12
        p.i_body_l {{ productDetail.Introduce_area01_Brief }}
    .row.i_mt_10
      .col-md-6
        h5.i_mb_4 {{ productDetail.Introduce_area01_Title01 }}
        oval-img-item.i_mt_2(
          v-for="(item, index) in productDetail.Introduce_area01_Content01",
          :key="index",
          :title="item.area01_Content01_Title",
          :img="item.area01_Content01_Image"
        )
      .col-md-6.i_mt_sm_6
        h5.i_mb_4 {{ productDetail.Introduce_area01_Title02 }}
        oval-img-item.i_mt_2(
          v-for="(item, index) in productDetail.Introduce_area01_Content02",
          :key="index",
          :title="item.area01_Content02_Title",
          :img="item.area01_Content02_Image"
        )

  //- 商品介紹頁-區塊二 影響示意圖
  distribution(
    :title="productDetail.Introduce_area02_Title",
    :subtitle="productDetail.Introduce_area02_SubTitle",
    :imgPC="productDetail.Introduce_area02_ImagePC",
    :imgMobile="productDetail.Introduce_area02_ImageMobile"
  )

  //- 商品介紹頁-區塊三 服務特色清單
  services(
    :title="productDetail.Introduce_area03_Title",
    :subtitle="productDetail.area03_Content_SubTitle",
    :contentList="productDetail.Introduce_area03_Content"
  )

  //- 商品介紹頁-區塊四 組合方案
  section.services.i_mt_8
  .head
    h2 {{ productDetail.Introduce_area04_Title }}
    p {{ productDetail.Introduce_area04_SubTitle }}
  .container-fluid.bg_blue
    solution(:contentList="productDetail.Introduce_area04_Content")

  //- 商品介紹頁-區塊五 附加商品
  additional-item(
    v-if="false",
    :additionalList="productDetail.Introduce_area05_AddProduct",
    :isBusiness="true"
  )

  media-img.golden_line_up.i_mt_8(:imgUrl="'golden_line_up'")

  //- 商品介紹頁-區塊六 商品問答
  section.container
    h2.i_h2_title.business.text-center.i_mt_10.i_mb_2 聚焦問題 解答疑惑
    p.i_body_l.text-center(v-if="false") 也歡迎至「
      span
        router-link(
          tag="a",
          :to="{ name: 'CustomerServiceContactUs' }",
          style="cursor: pointer; color: #3197fa"
        ) 聯絡我們
      | 」留下問題，將有專人主動聯繫回覆您
    .row
      .col-6.col-md-3.i_mt_8.i_mt_md_4(v-for="question in questions")
        question(:question="question")
    .row
      router-link.see_more_btn.sm.btn_blue.text-center.i_mtb_10(
        tag="a",
        :to="{ name: 'CustomerServiceFAQ' }"
      ) 看更多
</template>

<script>
import { getFAQDetail } from "@/json/FAQ";
import OvalImgItem from "@/components/product/Intro/BusinessIntro/OvalImgItem";
import Distribution from "@/components/product/Intro/BusinessIntro/Distribution";
import Services from "@/components/product/Intro/BusinessIntro/Services";
import Solution from "@/components/product/Intro/BusinessIntro/Solution";
import AdditionalItem from "@/components/product/Intro/AdditionalItem";
import Question from "@/components/common/Question";
import MediaImg from "@/components/common/MediaImg";

export default {
  name: "BusinessIntro",
  components: {
    distribution: Distribution,
    services: Services,
    solution: Solution,
    "additional-item": AdditionalItem,
    question: Question,
    "media-img": MediaImg,
    "oval-img-item": OvalImgItem,
  },
  props: {
    productDetail: Object,
  },
  data() {
    return {
      swiperOption: {
        notNextTick: true,
        initialSlide: 0,
        slidesPerView: 3,
        loop: false,
        direction: "horizontal",
        grabCursor: false,
        setWrapperSize: true,
        autoHeight: false,
        mousewheelControl: true,
        observeParents: true,
        debugger: true,
        paginationClickable: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      questions: [],
      FAQDetail: [],
      firstFlag: false,
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
    setBanner() {
      if (this.$store.state.screenWidth > 991) {
        return (
          "background-image: url('" +
          this.productDetail.Introduce_area01_BannerPC +
          "')"
        );
      } else if (this.$store.state.screenWidth > 767) {
        return (
          "background-image: url('" +
          this.productDetail.Introduce_area01_BannerTablet +
          "')"
        );
      } else {
        return (
          "background-image: url('" +
          this.productDetail.Introduce_area01_BannerMobile +
          "')"
        );
      }
    },
  },
  watch: {
    productDetail() {
      if (this.firstFlag) {
        this.getProductQuestion();
      }
    },
  },
  created() {
    this.getFAQDetail();
  },
  methods: {
    getFAQDetail() {
      getFAQDetail().then((response) => {
        this.FAQDetail = response.data.FAQDeatilList;
        this.getProductQuestion();
      });
    },
    getProductQuestion() {
      this.questions = [];
      if (
        this.productDetail.Introduce_area06_FAQ01ID &&
        this.productDetail.Introduce_area06_FAQ01ID != ""
      ) {
        for (let x in this.FAQDetail) {
          let detail = this.FAQDetail[x];
          if (this.productDetail.Introduce_area06_FAQ01ID == detail.FAQID) {
            this.questions.push(detail);
            break;
          }
        }
      }

      if (
        this.productDetail.Introduce_area06_FAQ02ID &&
        this.productDetail.Introduce_area06_FAQ02ID != ""
      ) {
        for (let x in this.FAQDetail) {
          let detail = this.FAQDetail[x];
          if (this.productDetail.Introduce_area06_FAQ02ID == detail.FAQID) {
            this.questions.push(detail);
            break;
          }
        }
      }

      if (
        this.productDetail.Introduce_area06_FAQ03ID &&
        this.productDetail.Introduce_area06_FAQ03ID != ""
      ) {
        for (let x in this.FAQDetail) {
          let detail = this.FAQDetail[x];
          if (this.productDetail.Introduce_area06_FAQ03ID == detail.FAQID) {
            this.questions.push(detail);
            break;
          }
        }
      }

      if (
        this.productDetail.Introduce_area06_FAQ04ID &&
        this.productDetail.Introduce_area06_FAQ04ID != ""
      ) {
        for (let x in this.FAQDetail) {
          let detail = this.FAQDetail[x];
          if (this.productDetail.Introduce_area06_FAQ04ID == detail.FAQID) {
            this.questions.push(detail);
            break;
          }
        }
      }

      this.firstFlag = true;
    },
    prevClick() {
      this.swiper.slidePrev();
    },
    nextClick() {
      this.swiper.slideNext();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/product/intro/intro";
@import "@/assets/style/product/intro/business_intro";
@import "@/assets/style/product/intro/business_intro_head";
</style>
